import { render, staticRenderFns } from "./sendTopic.vue?vue&type=template&id=27d94e43&scoped=true"
import script from "./sendTopic.vue?vue&type=script&lang=js"
export * from "./sendTopic.vue?vue&type=script&lang=js"
import style0 from "./sendTopic.vue?vue&type=style&index=0&id=27d94e43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d94e43",
  null
  
)

export default component.exports